import { render, staticRenderFns } from "./carExhibitionManager.vue?vue&type=template&id=36e32c98&lang=html"
import script from "./carExhibitionManager.vue?vue&type=script&lang=js"
export * from "./carExhibitionManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports